<template>
  <div id="options">
    <div v-for="option in product.options" :key="option.name">
      <OptionChoiceColor
          v-for="choice in option.choices" :key="choice.name || 0"
          :optionName="option.name"
          :choice="choice">
      </OptionChoiceColor>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import OptionChoiceColor from '@/components/OptionChoiceColor.vue';

export default {
  name: 'OptionSelector',
  components: {
    OptionChoiceColor,
  },
  props: {},
  data() {
    return {
      highlight: false,
    };
  },
  computed: mapState(['product']),
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
